import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { UploadDocResponse } from 'store/modules/models/uploadDocResponse';
import {
  CdcaApiResponse,
  CadastroCdcaApiRequest,
  GETInstrumentosFilterParams,
  HistoricoResponse,
  SolicitarLiquidacaoRequest,
  CommandResultTyped,
} from 'common/genericTypes';
import { errorMessages } from 'common/errorMessages.strings';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export const GETCdcaDetalhes = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
): Promise<CdcaApiResponse> => {
  return await request(
    () => axiosInstance.get<CdcaApiResponse>(`${requestConfig.api}api/v1/cdcas/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCdcas = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<CdcaApiResponse>> => {
  return await request(
    () => axiosInstance.get<Array<CdcaApiResponse>>(`${requestConfig.api}api/v1/cdcas`, params ? { params } : undefined),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCdcaByInstrumentoId = async (
  dispatch: Dispatch,
  instrumentoId: string,
  stackRequest: boolean = false
): Promise<CdcaApiResponse> => {
  return await request(
    () => axiosInstance.get<CdcaApiResponse>(`${requestConfig.api}api/v1/cdcas/instrumento-financeiro/${instrumentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTCdca = async (dispatch: Dispatch, cdca: CadastroCdcaApiRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CdcaApiResponse>(`${requestConfig.api}api/v1/cdcas`, cdca),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const PUTCdca = async (
  dispatch: Dispatch,
  cdcaId: string,
  cdca: CadastroCdcaApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.put<CdcaApiResponse>(`${requestConfig.api}api/v1/cdcas/${cdcaId}`, cdca),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTCdcaAditamento = async (
  dispatch: Dispatch,
  cdcaId: string,
  cdca: CadastroCdcaApiRequest,
  date: string,
  document: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();
  fileForm.append('file', document);
  fileForm.append('dataAditamento', date);
  fileForm.append('aditamento', JSON.stringify(cdca));

  return await request(
    () =>
      axiosInstance.put<string>(`${requestConfig.api}api/v1/cdcas/aditamento/${cdcaId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};


export const PUTEditarCdca = async (
  dispatch: Dispatch,
  cdcaId: string,
  cdca: CadastroCdcaApiRequest,
  justificativa: string,
  document?: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();

  if (document) fileForm.append('file', document);
  fileForm.append('justificativa', justificativa);

  const cdcaStringfyed = JSON.stringify(cdca);
  fileForm.append('instrumentoFinanceiroRequest', cdcaStringfyed);

  return await request(
    () =>
      axiosInstance.put<CommandResultTyped<string>>(`${requestConfig.api}api/v1/cdcas/editar/${cdcaId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTUploadDoc = async (
  dispatch: Dispatch,
  cdcaId: string,
  emissionType: string,
  file: File,
  stackRequest: boolean = false
) => {
  const data = new FormData();
  data.append('file', file);
  return await request<Array<UploadDocResponse>>(
    () =>
      axiosInstance.put<Array<UploadDocResponse>>(`${requestConfig.api}api/v1/cdcas/${cdcaId}/document`, data, {
        params: {
          emissionType,
        },
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEUploadDoc = async (
  dispatch: Dispatch,
  cdcaId: string,
  cdcaDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.delete(`${requestConfig.api}api/v1/cdcas/${cdcaId}/document/${cdcaDocumentId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCdcaDocumentDownloadUrl = async (
  dispatch: Dispatch,
  cdcaId: string,
  cdcaDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.get<string>(`${requestConfig.api}api/v1/cdcas/${cdcaId}/document/${cdcaDocumentId}/download`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTInterOpCdca = async (dispatch: Dispatch, cdca: CadastroCdcaApiRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CdcaApiResponse>(`${requestConfig.api}api/v1/cdcas/transferencia-dvm`, cdca),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTEnviarLiquidacao = async (
  dispatch: Dispatch,
  cdcaId: string,
  cdcaSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CdcaApiResponse>(
        `${requestConfig.api}api/v1/cdcas/${cdcaId}/enviar-liquidacao`,
        cdcaSolicitarLiquidacaoRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarLiquidacaoCdca = async (dispatch: Dispatch, cdcaId: string, precoUnitarioLiquidacao: number, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CdcaApiResponse>(`${requestConfig.api}api/v1/cdcas/${cdcaId}/confirmar-liquidacao`,
      { precoUnitario: precoUnitarioLiquidacao },
      { headers: { 'Content-Type': 'application/json' } }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETHistoricoCdca = async (dispatch: Dispatch, cdcaId: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<HistoricoResponse>>(`${requestConfig.api}api/v1/cdcas/${cdcaId}/historico-de-alteracoes`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAditamentoCDCA = async (dispatch: Dispatch, aditamentoId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<AditamentoRevisionData>(`${requestConfig.api}api/v1/cdcas/aditamento/${aditamentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAditamentoCDCA = async (dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.put<Array<AditamentoDiferenca>>(`${requestConfig.api}api/v1/cdcas/aditamento/atualizar/${aditamentoId}`, diferenca),
    dispatch,
    undefined,
    stackRequest
  );
};